import React from 'react';
import {Typography} from '@material-ui/core';
import styled from 'styled-components';

const Div = styled.div`
  margin-top: 10px;
  text-align: center;
`;

const Forbidden = () => {
  return (
      <div>
        <Typography align="center" variant="h4">
          Данная ссылка недействительна
        </Typography>
        <Div>
          <Typography variant="subtitle1">
            Возможно, истёк срок её действия, либо вы ошиблись с написанием.
          </Typography>
          <Typography variant="subtitle1">
            Если у вас есть вопросы,
            пожалуйста, позвоните нам:
            +7&nbsp;(423)&nbsp;203-02-02
          </Typography>
        </Div>
      </div>
  );
};

export default Forbidden;
